<template>
    <div class="confetti" />
</template>

<script>
import {getRandomInt, getRandomNumber} from '@kids/lib/task';
import gsap from 'gsap';

const {document} = globalThis;

export default {
    name: 'Confetti',
    mounted()
    {
        for (let i = 0; i < 60; i++)
        {
            this.$el.appendChild(document.createElement('div'));
        }
    },
    methods:
    {
        animate()
        {
            const width = this.$el.offsetWidth;
            const maxParticleSize = width * 0.025 * 2;
            const maxParticleSizeDoubled = maxParticleSize * 2;
            const y = this.$el.offsetHeight + maxParticleSize;

            Array.from(this.$el.children).forEach((particle) =>
            {
                gsap.killTweensOf(particle);
                particle.className = '';
                particle.classList.add('particle', `type${getRandomInt(1, 8)}`);
                gsap.set(particle, {
                    scale: getRandomNumber(1, 2),
                    x: getRandomInt(maxParticleSizeDoubled, width - maxParticleSizeDoubled),
                    y: getRandomInt(-maxParticleSize - 100, -maxParticleSize),
                    rotateX: 0,
                    rotateZ: 0,
                    opacity: 1
                });
                this._animateParticle(particle, y);
            });
        },
        _animateParticle(particle, y)
        {
            gsap.to(particle, {
                duration: getRandomNumber(1.5, 3.5),
                y,
                x: `+=${getRandomInt(-500, 500)}`,
                rotateZ: getRandomInt(-180, 180),
                rotateX: getRandomInt(-360, 360),
                delay: getRandomNumber(0, 2),
                ease: 'power2.out',
                clearProps: true
            });
        }
    }
};
</script>

<style lang="scss" src="./Confetti.scss" />
